<template>
  <div
    v-if="props.visible"
    class="i-modal-payment"
    :style="{ 'z-index': props.zIndex }"
  >
    <div class="outer-wrapper">
      <button
        class="close-modal"
        @click="clickOnClose"
      >
        <img
          :src="iconCloseButtonBlack"
          loading="lazy"
          alt="Close"
          class="close-modal-icon"
        />
      </button>

      <div class="payment-container">
        <slot name="top">
          <!-- Use it to add custom html -->
        </slot>

        <div class="inner-wrapper">
          <slot name="center">
            <!-- Use it to add custom html -->
          </slot>
        </div>

        <slot name="bottom">
          <!-- Use it to add custom html -->
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { zIndexModal } from "@/styles/variables"

import iconCloseButtonBlack from "@/assets/buttons/close-button-black.svg"

const emit = defineEmits(["clickOnClose"])

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  zIndex: {
    type: Number,
    default: zIndexModal
  }
})

function clickOnClose() {
  emit("clickOnClose")
}
</script>

<style lang="scss" scoped>
.i-modal-payment {
  position: fixed;
  inset: 0%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba($pickle-bluewood950, 0.96);

  .outer-wrapper {
    position: relative;
    overflow: scroll;
    width: 90%;
    height: fit-content;
    max-height: 90%;
    margin-right: auto;
    margin-left: auto;
    border-radius: 16px;
    background-color: $black50;

    .close-modal {
      position: absolute;
      inset: 4px 4px auto auto;
      z-index: $z-index-modal + $z-index-above;
      padding: 4px;
      border-radius: 32px;
      background-color: #e8e8e8;
      box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%);
      transition: background-color 200ms ease;
      cursor: pointer;
    }

    .close-modal:hover {
      background-color: #b3b3b3;
    }

    .close-modal-icon {
      width: 32px;
      height: 32px;
    }

    .payment-container {
      display: flex;
      width: 95%;
      max-width: 1498px;
      margin-right: auto;
      margin-left: auto;
      flex-direction: column;
      justify-content: center;

      .inner-wrapper {
        margin: 0 auto;
        position: relative;
        z-index: $z-index-modal;
        padding-top: 32px;
        padding-bottom: 32px;

        @media screen and (min-width: $breakpoint-md) {
          padding-top: 64px;
          padding-bottom: 64px;
        }
      }
    }
  }
}

@media screen and (min-width: $breakpoint-md) {
  .i-modal-payment {
    .close-modal {
      top: 8px;
      right: 8px;
    }
  }
}
</style>
